import React, { Component } from "react"
import PropTypes from "prop-types"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import * as actions from "./redux/actions"
import { LogoutLink } from "./index"
import LogoutIcon from "../../images/icons/logout-108.png"

export class CurrentUser extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    className: PropTypes.string,
  }

  render() {
    return (
      <div className={`auth-current-user ${this.props.className}`}>
        <div className="user-image">
          <div className="placeholder">?</div>
        </div>
        <div className="username">{this.props.auth.username}</div>
        <LogoutLink>
          <img className="icon icon-logout" alt="Ausloggen" src={LogoutIcon} />
        </LogoutLink>
      </div>
    )
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    auth: state.auth,
  }
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CurrentUser)



// WEBPACK FOOTER //
// ./src/features/auth/CurrentUser.js